import {Button, Card, CardContent} from '@material-ui/core';
import {sequenceT} from 'fp-ts/lib/Apply';
import {io} from 'fp-ts/lib/IO';
import qs from 'query-string';
import React from 'react';
import {RouteComponentProps, withRouter} from 'react-router';
import {clearAccessTokenFromLocalStorage, logout} from 'Shared/utilities/Auth';
import {LocalStorageKey, toLocalStorage} from 'Shared/utilities/localStorage';
import {UserRouteConstants} from 'Users/Routes';
import './IndependentAgentRegistration.sass';

type IndependentAgentRegistrationProps = RouteComponentProps;

const storeSignUpKey = toLocalStorage(LocalStorageKey.IndependentAgentRegistrationKey);
const redirectToLogin = () => {
  window.location.assign(process.env.REACT_APP_BASE_SITE_URL!);
};

const IndependentAgentRegistration = (props: IndependentAgentRegistrationProps) => {
  const response = qs.parse(props.location.search);
  const containsSpecialCharacter = /[^A-Za-z0-9]+/;

  const signUpKey = containsSpecialCharacter.test(response.key as string) ? 'invalidKey' : (response.key as string);

  const redirectToSignUpForm = () => props.history.push(UserRouteConstants.EXTERNAL_USER_SIGN_UP(signUpKey));

  const setupNewAccount = sequenceT(io)(redirectToSignUpForm, storeSignUpKey(response.key));

  const setupExistingAccount = sequenceT(io)(
    clearAccessTokenFromLocalStorage,
    storeSignUpKey(response.key),
    logout,
    redirectToLogin
  );

  return (
    <div className="independent-agent-registration">
      <h1 className="independent-agent-registration__header">Welcome to MyAccess</h1>
      <p>Benefits Management System</p>
      <p>To complete agency onboarding, please select the appropriate option below:</p>
      <div className="independent-agent-registration__cards">
        <Card className="cards__card">
          <CardContent className="card__content">
            <p className="card__title">I already have a MyAccess Account.</p>
            <Button fullWidth onClick={setupExistingAccount} variant="contained" color="primary">
              Login
            </Button>
          </CardContent>
        </Card>
        <Card className="cards__card">
          <CardContent className="card__content">
            <p className="card__title">I do not have a MyAccess Account.</p>
            <Button fullWidth variant="contained" color="primary" onClick={setupNewAccount}>
              Create New Account
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default withRouter(IndependentAgentRegistration);
